import React from "react";
import { useAlerts } from "./AlertContext";
import AlertHolder from "./AlertHolder";
const AlertsFromProvider = () => {
    const { alerts, removeAlert } = useAlerts();
    return React.createElement(AlertHolder, { alerts: alerts, onRemove: removeAlert });
};
export default AlertsFromProvider;
//# sourceMappingURL=AlertsFromProvider.js.map